const extractBaseIp = (ip: string): string => {
    let cleanIp = ip;
    // If subnet (e.g., 192.168.1.0/24), remove CIDR
    if (cleanIp.includes('/')) {
        cleanIp = cleanIp.split('/')[0];
    }
    // If range (e.g., 192.168.1.1-192.168.1.10), use first IP
    if (cleanIp.includes('-')) {
        cleanIp = cleanIp.split('-')[0];
    }
    return cleanIp;
};

const convertIpV4ToHex = (cleanIp: string) => {
    return cleanIp.split('.')
        .map(octet => (+octet).toString(16).padStart(2, '0'))
        .join('').padStart(32, '0');
};

const expandIpV6ToHex = (cleanIp: string) => {
    let fullIp = cleanIp;
    if (cleanIp.includes('::')) {
        const parts = cleanIp.split('::');
        const left = parts[0].split(':').filter(Boolean);
        const right = parts[1] ? parts[1].split(':').filter(Boolean) : [];
        const missing = 8 - (left.length + right.length);
        fullIp = [...left, ...new Array(missing).fill('0'), ...right].join(':');
    }
    return fullIp.split(':')
        .map(block => block.padStart(4, '0'))
        .join('');
};

// Converts IPv4 or IPv6 address to a hexadecimal string for sorting
const ipToHex = (ip: string): string => {
    if (!ip) return '';
    const cleanIp = extractBaseIp(ip).trim();
    // IPv4
    if (cleanIp.includes('.')) {
        return convertIpV4ToHex(cleanIp);
    }
    // IPv6
    if (cleanIp.includes(':')) {
        // Expand IPv6
        return expandIpV6ToHex(cleanIp);
    }
    return cleanIp;
};

export const sortByIpHex = (accessor: string, a: any, b: any, direction: 'asc' | 'desc'): number => {
    const aIp = a[accessor];
    const bIp = b[accessor];
    const aHex = ipToHex(aIp);
    const bHex = ipToHex(bIp);
    return direction === 'asc'
        ? aHex.localeCompare(bHex)
        : bHex.localeCompare(aHex);
};

export function sortString<T>(column: keyof T, direction: 'asc' | 'desc', a: T, b: T): number {
    const aValue = a[column] ?? '';
    const bValue = b[column] ?? '';
    const res = String(aValue).localeCompare(String(bValue));
    return direction === 'asc' ? res : -res;
}
